<template>
  <div class="content">
    <span>Ông/bà</span>
    <span class="highlight font-weight__bold"> {{ fromActorFullName }} </span>
    <span>đã</span>
    <span class="highlight-action"> {{ action }} </span>
    <span> {{ subAction }} </span>
    <span class="event">"{{ quote }}"</span>
  </div>
</template>

<script>
import constants from "../../constants";

export default {
  name: "notification-item-vb",
  props: ["vbNotificationView"],
  data() {
    return {
      fromActorFullName: null,
      action: null,
      quote: null,
      dataJson: null,
      subAction: "",
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      // console.log(this.vbNotificationView.dataJson);
      this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
      let action;
      let subAction;
      let fromActor;
      switch (this.vbNotificationView.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.OUTGOING_COMMENT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_COMMENT:
          action = "gửi bình luận";
          subAction = "trong văn bản về việc";
          fromActor = this.dataJson.fromActor;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CC_DOC_IN:
          action = "cc bạn";
          subAction = "trong văn bản về việc";
          fromActor = this.dataJson.fromActor;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_TUCHOI:
          action = "đã từ chối";
          subAction = "đã từ chối văn bản về việc";
          fromActor = this.dataJson.fromActor;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.OUTGOING_KETTHUC:
          action = "đã phê duyệt";
          fromActor = this.dataJson.fromActor;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.THU_HOI_CC:
          action = "đã thu hồi văn bản";
          fromActor = this.dataJson.fromActor;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.VB_BANGIAO:
          action = "Bàn giao";
          break;
        default:
          break;
      }
      if (
        this.vbNotificationView.messageType ===
          constants.VB_NOTIFICATION.MESSAGE_TYPE.THU_HOI_CC ||
        this.vbNotificationView.messageType ===
          constants.VB_NOTIFICATION.MESSAGE_TYPE.VB_BANGIAO
      ) {
        this.fromActorFullName = this.vbNotificationView.fromUserName
          ? this.vbNotificationView.fromUserName
          : "-";
      } else {
        this.fromActorFullName = fromActor ? fromActor.fullName : "-";
      }
      this.action = action;
      this.subAction = subAction;
      if (
        this.vbNotificationView.messageType ===
        constants.VB_NOTIFICATION.MESSAGE_TYPE.THU_HOI_CC
      ) {
        this.quote = this.dataJson.object.quote;
      } else if (
        this.vbNotificationView.messageType ===
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CC_DOC_IN
      ) {
        this.quote = this.dataJson.vbIncomingDoc.quote;
      } else {
        this.quote = this.dataJson.data.quote;
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/notification-item-vb.vue